import { NgModule } from '@angular/core';
import { CamelcasePipe } from './camelcase/camelcase';
import { FiltroarrayPipe } from './filtroarray/filtroarray';
@NgModule({
	declarations: [CamelcasePipe,
    FiltroarrayPipe],
	imports: [],
	exports: [CamelcasePipe,
    FiltroarrayPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/pipes/pipes.module.ts